<template>
  <div id="app">
    <baseHeader></baseHeader>
    <div id="main">
      <router-view></router-view>
    </div>
    <baseFooter></baseFooter>
    <popInfo :modalFlag="modalFlag" :img="img" @closeModal="toggleModal"/> 
  </div>
</template>

<script>
import BaseHeader from "@/components/base/BaseHeader";
import BaseFooter from "@/components/base/BaseFooter";
import popInfo from '@/components/base/PopInfo'
export default {
  name: "main",
  data() {
    return {
      modalFlag: true,
      // 下面是 pop window 參數
      img: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/FBBN3.jpg',
      closeTime: '2020-02-10 09:57',
    }
  },
  components: {
    baseHeader: BaseHeader,
    baseFooter: BaseFooter,
    popInfo: popInfo
  },
  created() {
    this.timeToClose()
  },
  methods: {
    toggleModal() {
      this.modalFlag = false;
    },
    timeToClose(){
      Date.parse(this.closeTime) - Date.parse(new Date()) >= 0 ? this.modalFlag = true : this.modalFlag = false
    }
  }
};
</script>
